// extracted by mini-css-extract-plugin
module.exports = {"button":"i_Hp","label":"i_Hq","icon":"i_Hr","major":"i_Hs","minor":"i_Ht","negative":"i_Hu","destructive":"i_Hv","special":"i_Hw","diminished":"i_Hx"};